import script from "./FlowPreviewCustomFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlowPreviewCustomFields.vue?vue&type=script&setup=true&lang=ts"

import "./FlowPreviewCustomFields.vue?vue&type=style&index=0&id=294c0c3b&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-294c0c3b"]])

export default __exports__